import { render, staticRenderFns } from "./BindModal.vue?vue&type=template&id=0163dc34&scoped=true&"
import script from "./BindModal.vue?vue&type=script&lang=js&"
export * from "./BindModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0163dc34",
  null
  
)

export default component.exports